const styles = theme => ({
  buttonsStyle: {
    flexDirection: 'row',
    width: '100%',
    display: 'flex',
    gap: '5px',
    justifyContent: 'flex-end',
    margin: '8px 0px',
  },
})
export default styles
